// available-pathways.js — the allowlist of study paths the switcher exposes.
//
// Brief 157. All 8 pathways regenerated from the canonical decrypted packages
// (Brief 094) live under content/pathways/. iOS exposes every pathway to paid
// learners (KFEChangeStudyPathViewController lists the root plist's
// `originalItems` in order; only the trial-user "hide study path" entitlement
// curates the list down — out of scope here, see Brief 157 §Notes on scope).
//
// The web build exposes all 8. This list is the single curation point: the order
// here IS the switcher's row order, and if the content team later flags a pathway
// as internal-only, commenting it out (plus a content-team question) is the
// whole change — no other code touches the set.

/** @type {string[]} */
export const AVAILABLE_PATHWAYS = [
  "kfe_zero_to_fluency",
  "kfe_180_days_step_by_step",
  "kfe_advanced_learners",
  "kfe_business_english",
  "kfe_going_abroad",
  "kfe_skills_based_training",
  "kfe_useful_information",
  "kfe_other_products_and_services",
];
